<script lang="ts">
    import { _ } from 'svelte-i18n';
    import { StaticLoader } from "../helpers/static";
    import SearchBar from "../components/SearchBar.svelte";
    import Results from "../components/Results.svelte";

    export let participant: string = '';
    let searchString = '';
    let results = {id: '', search: '', filter: 'all', auto: true};
    let direction = '';
    let search = false;
    let idLoad = false;

    if (participant != '') {
        results.id = participant;
        idLoad = true;
    }

    function loadResults(e: CustomEvent) {
        results = e.detail;
        idLoad = false;
    }

    function handleArrow(e: CustomEvent) {
        direction = '';
        direction = e.detail;
    }

    function handleSearch(e: CustomEvent) {
        if (e.detail) {
            results = {id: '', search: '', filter: 'all', auto: true};
            search = e.detail;
        } else {
            search = false;
        }
    }

    function clearResults() {
        results = {id: '', search: '', filter: 'all', auto: true};
        idLoad = false;
        search = false;
    }

    function mobBack(e: CustomEvent) {
        searchString = results.search;
        if (searchString == '') {
            searchString = e.detail;
        }
        results = {id: '', search: '', filter: 'all', auto: true};
    }
</script>

<div class="container min-h-full lg:max-w-[60%] mx-auto px-4 overscroll-auto bg-primary pt-1 pb-1">
    <h1 class="text-3xl mt-4 md:mt-12">{$_("search.title")}</h1>
    <SearchBar on:result={loadResults} on:arrow={handleArrow} on:clear={clearResults} on:search={handleSearch}
               on:back={() => searchString = ''} searchStringBack={searchString} />
    <Results search={results} arrow={direction} on:back={mobBack} />
    {#if search === false && idLoad === false}
        <div class="mt-4">
            <svelte:component this={StaticLoader('search', $_('code'))} />
        </div>
    {/if}
</div>

<style windi:preflights>
</style>
